const RANKING = [
  {
    rank: 1,
    title: '废柴逆袭手册',
    tag: '搞笑',
    score: '580万',
    label: '总阅读',
    change: 'up',
    desc: '沙雕社畜的爆笑逆袭之路，每天更新笑料不断。',
  },
  {
    rank: 2,
    title: '办公室罗曼史',
    tag: '韩漫',
    score: '472万',
    label: '总阅读',
    change: 'up',
    desc: '霸道总裁与职场新人的高甜恋爱日常。',
  },
  {
    rank: 3,
    title: '长安幻夜行',
    tag: '国漫',
    score: '389万',
    label: '总阅读',
    change: 'up',
    desc: '盛唐奇幻探案，画风精美剧情层层递进。',
  },
  {
    rank: 4,
    title: '她的私密日记',
    tag: '韩漫',
    score: '315万',
    label: '总阅读',
    change: 'new',
    desc: '细腻描绘都市女性内心世界，口碑持续走高。',
  },
  {
    rank: 5,
    title: '第七层密室',
    tag: '悬疑',
    score: '278万',
    label: '总阅读',
    change: 'up',
    desc: '豆瓣9.7分悬疑神作，每话结尾高能反转。',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            人气排行
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            站内热门漫画TOP5，大家都在看
          </p>
        </div>

        <div className="space-y-3">
          {RANKING.map((item, idx) => (
            <div
              key={idx}
              className="flex items-center gap-3 md:gap-5 p-4 md:p-5 bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer group"
            >
              <div className={`flex-shrink-0 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-lg font-heading font-bold text-sm md:text-base ${
                item.rank === 1
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 3
                  ? 'bg-secondary-500 text-background-50'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <span className="px-1.5 py-0.5 rounded text-xs font-medium bg-background-100 text-foreground-500 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs md:text-sm text-foreground-500 line-clamp-1">
                  {item.desc}
                </p>
              </div>

              <div className="flex-shrink-0 text-right">
                <div className="text-sm md:text-base font-bold text-foreground-800">
                  {item.score}
                </div>
                <div className="text-xs text-foreground-400">{item.label}</div>
              </div>

              <div className="flex-shrink-0">
                {item.change === 'up' ? (
                  <span className="flex items-center gap-0.5 text-xs text-primary-500 font-medium">
                    <i className="ri-arrow-up-line"></i>
                  </span>
                ) : item.change === 'new' ? (
                  <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                    NEW
                  </span>
                ) : null}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}